export const ItemUnavailable: React.FC = () => {
  return (
    <div data-testid="item-unavailable" className="item-unavailable">
      Unavailable
    </div>
  );
};
